export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESSFUL = "LOGIN_SUCCESSFUL";
export const LOGIN_ERROR = "LOGIN_ERROR";


export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESSFUL = "REGISTER_SUCCESSFUL";
export const REGISTER_ERROR = "REGISTER_ERROR";


export const GET_USERS = 'GET_USERS'
export const LOGOUT_USER = 'LOGOUT_USER'